import styled from "styled-components";

import { PT_STRIP_ATTR, PT_STRIP_CONTENT_VISIBLE_ATTR } from "app/components/PageTopBanner/bannerRevealContext";
import { BANNER_REVEAL_ANIMATION_MS } from "app/components/PageTopBanner/useBannerRevealAnimation";

// Centralized animation rules for any banner whose colored root is marked
// with `data-pt-strip` (via `usePageTopBannerStripReveal`).
//   1. Strip animates its own height from 0 to its target — the colored
//      background grows in place (no empty wrapper above the banner).
//   2. After the height transition finishes, direct children fade in.
export const PageTopBannerHost = styled.div`
    & [${PT_STRIP_ATTR}] {
        box-sizing: border-box;
        min-height: 0;
        overflow: hidden;
        transition: height ${BANNER_REVEAL_ANIMATION_MS}ms ease-out;
    }

    & [${PT_STRIP_ATTR}] > * {
        opacity: 0;
        transition: opacity ${BANNER_REVEAL_ANIMATION_MS}ms ease-out;
    }

    & [${PT_STRIP_ATTR}][${PT_STRIP_CONTENT_VISIBLE_ATTR}] > * {
        opacity: 1;
    }
`;
